/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_PostInputs */

const vi_shop_home_link_post = /** @type {(inputs: Shop_Home_Link_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài viết`)
};

/**

* @param {Shop_Home_Link_PostInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_post = /** @type {((inputs?: Shop_Home_Link_PostInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_PostInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_post(inputs)
});